import { apiFetchLong } from './api';

/**
 * Lit un texte collé et propose des valeurs pour les champs d'un formulaire.
 * `champs` : [{ cle, libelle, type?, options? }] ; renvoie { cle: valeur }.
 */
export async function remplirFormulaireDepuisTexte({ texte, champs, contexte }) {
  return (await lireFormulaireDepuisTexte({ texte, champs, contexte })).valeurs;
}

/**
 * Comme ci-dessus, et pour un devis : `formations` ([{ id, code, intitule }])
 * demande aussi les LIGNES du devis. Renvoie { valeurs, lignes, ignorees }.
 */
export async function lireFormulaireDepuisTexte({ texte, champs, contexte, formations }) {
  const res = await apiFetchLong('/ia/remplir-formulaire', {
    method: 'POST',
    body: JSON.stringify({ texte, champs, contexte, formations }),
  });
  return { valeurs: res.data || {}, lignes: res.lignes || [], ignorees: res.ignorees || [] };
}
